import {
  RouteInterface,
  CcfHome,
  CcfPreviewImage,
  CcfPatronLite,
} from '@nice-ccf/ui-components';
import { Redirect } from 'react-router-dom';
import Simulator from '../simulator/simulator';
import { Box } from '@mui/material';
import Admin from '../admin/admin';
import PrivateRoute from './privateRoute';

export const routes: RouteInterface[] = [
  {
    path: '/home',
    private: false, //disable login for local development
    component: <CcfHome />,
    children: [
      {
        path: '/home/previewMode',
        private: false,
        component: (
          <Box display="flex" marginX={2} marginY={1.5} flex="1">
            <CcfPreviewImage isOpen={true} imgIndex={0} />
          </Box>
        ),
      },
    ],
  },
  {
    path: '/simulator',
    private: false,
    component: <Simulator />,
  },
  {
    path: '/admin',
    private: false,
    component: <PrivateRoute component={Admin} />,
  },
  {
    path: '/patron',
    private: false,
    component: <CcfPatronLite />,
  },
  {
    path: '*',
    private: false,
    component: <Redirect to="/home" />,
  },
];
